import type { IProgressBarProps } from 'atoms/ProgressBar'

import { Corners, ProgressBar } from 'atoms/ProgressBar'
import { WrapperBlock } from 'atoms/WrapperBlock'

export const ContinueWatchCardProgressBar = ({
  color,
  progress,
}: IProgressBarProps) => {
  return (
    <WrapperBlock>
      <ProgressBar
        progress={progress}
        color={color}
        corners={Corners.CORNERS_0}
      />
    </WrapperBlock>
  )
}
